import React from "react";
import { merge } from "lodash";
import Notification, { NotificationProps as BaseNotificationProps, NotificationOptions } from "./Notification";

export type SuccessNotificationProps =
    Pick<BaseNotificationProps, "id" | "message" | "onClose"> &
    Partial<Omit<BaseNotificationProps, "id" | "message" | "onClose">> & {
        options?: NotificationOptions;
    };

const defaultOptions: NotificationOptions = {
    containerClass: "text-success-700 bg-success-100 border border-success-700",
    iconClass: "fill-success-700",
    iconSrc: "/icons/check-green.svg"
};

export const SuccessNotification: React.FC<SuccessNotificationProps> = ({
    containerClass,
    iconClass,
    iconSrc,
    id,
    message,
    options = {},
    // Callbacks
    onClose,
    // Rest
    ...restOfBaseProps
}: SuccessNotificationProps) => {
    const mergedOptions: NotificationOptions = merge({}, defaultOptions, options);

    return (
        <Notification
            containerClass={containerClass || mergedOptions.containerClass}
            iconClass={iconClass || mergedOptions.iconClass}
            iconSrc={iconSrc || mergedOptions.iconSrc}
            buttonClass={mergedOptions.buttonClass}
            buttonIcon={mergedOptions.buttonIcon}
            id={id}
            message={message}
            // Callbacks
            onClose={onClose}
            // Rest
            {...restOfBaseProps}
        />
    );
};

export default SuccessNotification;